// =====================================================================
// DESK FIXES — intentionally a NO-OP (zero runtime footprint)
// =====================================================================
// Post-mortem of the regressions:
//   • v1 reparented Frappe dropdowns to <body> → crashed list_filter.js
//     and broke the Child Table.
//   • v2 used a document-wide MutationObserver (subtree+childList) for
//     checkbox de-dup. On Frappe's grid (which does massive DOM churn
//     when a Child Table row is opened) this per-frame whole-document
//     scan interfered with rendering → blank page / hang.
//
// CONCLUSION: any global observer/DOM mutation against Frappe's desk is
// inherently risky. The checkbox duplicate is now fully handled in pure
// CSS (`_form.scss` :has() multi-anchor rule + Frappe's own .hide flag),
// which is zero-risk. So this module deliberately does NOTHING at
// runtime. Kept as a stable export so the bundle entry stays unchanged.
// =====================================================================

export const deskFixes = {
	mount() {
		/* no-op by design — see header. */
	},
};
